import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Alerta } from './alerta.types';
import { AlertaService } from './alerta.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-alerta',
    animations: [
        trigger('exibir', [
            state(
                'abaixo',
                style({
                    top: '120%',
                    opacity: '0.1',
                })
            ),
            state(
                'acima',
                style({
                    top: '88%',
                    opacity: '1.0',
                })
            ),
            transition('* => *', [animate('0.5s')]),
        ]),
    ],
    template: `
        @if (alerta$ | async; as alerta) {
            <div [@exibir]="(exibido$ | async) ? 'acima' : 'abaixo'" class="alerta">
                <img src="icons/outline/check.svg" alt="check" />
                <p class="body3 medium">{{ alerta?.mensagem }}</p>
            </div>
        }
    `,
    styleUrls: ['./alerta.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe],
})
export class AlertaComponent implements OnDestroy {
    private alertaService = inject(AlertaService);

    public exibido$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public alerta$: BehaviorSubject<Alerta | null>;

    private readonly animacaoTimeout: number = 5000;

    constructor() {
        this.alerta$ = this.alertaService.alerta$;
        this.alertaService.aoIncluirAlerta = this.realizarAnimacao;
    }

    ngOnDestroy(): void {
        this.exibido$.unsubscribe();
        this.alerta$.unsubscribe();
    }

    private realizarAnimacao = (): void => {
        this.exibido$.next(true);
        setTimeout(() => this.exibido$.next(false), this.animacaoTimeout);
    };
}
